import { render, staticRenderFns } from "./ReailzeCard.vue?vue&type=template&id=40d5f23d&scoped=true"
import script from "./ReailzeCard.vue?vue&type=script&lang=js"
export * from "./ReailzeCard.vue?vue&type=script&lang=js"
import style0 from "./ReailzeCard.vue?vue&type=style&index=0&id=40d5f23d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d5f23d",
  null
  
)

export default component.exports